import _default from './Button';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Button/index.js
// module id = 142
// module chunks = 0